<template>
  <vx-card>
    <!-- <div class="vx-card"> -->
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <!-- Broadcaster -->
    <div v-else class="w-full">
      <div
        slot="no-body"
        class="tabs-container pt-6 inventory_tabSec"
        id="view-customer-tab"
      >
        <div
          class="mr-2 mb-1 order-1"
          style="margin-left: auto; margin-right: auto; text-align: center"
        ></div>
        <!-- <vs-divider /> -->
        <vs-table
          @selected="handleSelected"
          :max-items="descriptionItems[0]"
          pagination
          :data="channelList"
          description
          search
          :description-items="descriptionItems"
          description-title="Registries"
          description-connector="of"
          description-body="Pages"
        >
          <template slot="header">
            <div class="list-heading">
              {{ $t("setup.label.Channel") }}
            </div>

            <div class="mr-2 mb-1 order-1">
              <vs-button
                icon-pack="feather"
                icon="icon-plus"
                color="success"
                type="border"
                @click="$router.push({ name: 'Create Broadcaster' })"
                size="small"
                >{{ $t("setup.label.CreateBroadcaster") }}</vs-button
              >
            </div>
            <div class="mr-2 mb-1 order-1">
              <vs-button
                icon-pack="feather"
                icon="icon-plus"
                @click="$router.push({ name: 'Create Channel' })"
                size="small"
                >{{ $t("setup.label.CreateChannel") }}</vs-button
              >
            </div>
          </template>
          <template slot="thead">
            <vs-th>{{ $t("setup.label.ChannelName") }}</vs-th>
            <vs-th>{{ $t("setup.label.ChannelCategory") }}</vs-th>
            <vs-th>{{ $t("setup.label.ChannelSequence") }}</vs-th>
            <vs-th>{{ $t("setup.label.BroadcasterName") }}</vs-th>
            <vs-th>{{ $t("setup.label.IsHdChannel") }}</vs-th>
            <vs-th class="tHeadCenter">{{ $t("setup.label.Actions") }}</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr
              :key="index"
              :data="channel"
              v-for="(channel, index) in data"
            >
              <vs-td :data="channel.channelName">{{
                channel.channelName
              }}</vs-td>
              <vs-td :data="channel.channelCategory">{{
                channel.channelCategory
              }}</vs-td>
              <vs-td :data="channel.channelSequence">{{
                channel.channelSequence
              }}</vs-td>
              <vs-td :data="channel.broadcasterName">{{
                channel.broadcasterName
              }}</vs-td>
              <vs-td :data="channel.isHdChannel">{{
                channel.isHdChannel
              }}</vs-td>
              <vs-td class="whitespace-no-wrap">
                <div class="container_img">
                  <feather-icon
                    icon="EyeIcon"
                    :title="$t('setup.label.View')"
                    svgClasses="w-5 h-5 stroke-current cursor text-primary"
                    @click.stop="handleSelected(channel)"
                    class="icon_row"
                  />
                  <feather-icon
                    icon="EditIcon"
                    :title="$t('setup.label.Edit')"
                    svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                    @click.stop="editchannel(channel.id)"
                    class="icon_row"
                  />
                  <feather-icon
                    icon="TrashIcon"
                    :title="$t('setup.label.Delete')"
                    svgClasses="w-5 h-5 text-danger stroke-current cursor"
                    @click.stop="
                      stateChange('Channel');
                      editJobsPopup = true;
                      delId = channel.id;
                    "
                    class="icon_row"
                  />
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>
    <!--  -->
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="'Delete ' + title"
        :active.sync="editJobsPopup"
        class="popup-close small-popup"
      >
        <div class="center">
          <img src="@/assets/images/pages/delete.svg" />
          <div class="success-msg">{{$t("setup.label.Are_you_sure_you_want_to_delete_?")}}</div>
        </div>

        <div class="center">
          <span class="p-2">
            <vs-button type="border" @click="editJobsPopup = false">{{
              $t("setup.label.Cancel")
            }}</vs-button></span
          >

          <span class="p-2">
            <vs-button @click="deleteData(delId)">{{
              $t("setup.label.Confirm")
            }}</vs-button>
          </span>
        </div>
        <div style="height: 20px"></div>
      </vs-popup>
    </div>
  </vx-card>
</template>
<script>
import { mapState } from "vuex";
import { AtomSpinner } from "epic-spinners";

export default {
  data() {
    return {
      loading: false,
      title: "Broadcaster",
      // activeTab: "Broadcaster",
      searchOption: 0,
      togglebroadcaster: true,
      togglechannel: false,
      toggleproductmapping: false,
      descriptionItems: [5, 10, 15],
      editJobsPopup: false,
      delId: 0,
      broadcasterUsers: [],

      toggleTable: "",
      pages1: [
        { name: "Broadcaster", active: "active" },
        { name: "Channel", active: "inactive" },
        { name: "Product Mapping", active: "inactive" },
      ],
    };
  },
  components: { AtomSpinner },
  computed: {
    // itemModels() {
    //   return this.$store.getters["ItemModel/getbroadcasterUserList"];
    // },
    ...mapState({
      broadcasterList: (state) => state.broadcaster.broadcasterList,
      channelList: (state) => state.broadcaster.channelList,
      productList: (state) => state.broadcaster.productList,
    }),
  },
  methods: {
    stateChange(name) {
      let i = 0;
      this.title = name;
      if (name === "Broadcaster") {
        this.togglebroadcaster = true;
        this.togglechannel = false;
        this.toggleproductmapping = false;
        this.getbroadcasterData();
      } else if (name === "Channel") {
        this.togglebroadcaster = false;
        this.togglechannel = true;
        this.toggleproductmapping = false;
        this.getChannelData();
      } else {
        this.togglebroadcaster = false;
        this.togglechannel = false;
        this.toggleproductmapping = true;
        this.getProductMapping();
      }
      for (let temp of this.pages1) {
        if (temp.name === name) {
          this.pages1[i].active = "active";
        } else {
          this.pages1[i].active = "inactive";
        }
        i += 1;
      }
    },
    handleSelected(channel) {
      this.$router.push({ name: "Channel View", params: { id: channel.id } });
    },
    handleSelected1(broadcaster) {
      this.$router.push({
        name: "View Broadcaster",
        params: { id: broadcaster.id },
      });
    },
    handleSelected2(product) {
      this.$router.push({
        name: "View Product Mapping",
        params: { id: product.productId, product: product },
      });
    },
    handlebroadcasterUserSelected(item) {
      this.$router.push({ path: `/viewbroadcasteruser/${item.broadcasterId}` });
    },
    async getbroadcasterData() {
      this.loading = true;
      try {
        await this.$store.dispatch("broadcaster/setBroadcasterList");
      } catch (e) {
        this.$toasted.error(e.message);
      }
      this.loading = false;
    },
    async getChannelData() {
      this.loading = true;
      try {
        this.$store.dispatch("broadcaster/setChannelList");
      } catch (e) {
        this.$toasted.error(e.message);
      }
      this.loading = false;
    },
    async getProductMapping() {
      this.loading = true;
      try {
        this.$store.dispatch("broadcaster/setProductMappingList");
      } catch (e) {
        this.$toasted.error(e.message);
      }
      this.loading = false;
    },

    async getbroadcasterUserList() {
      try {
        const sup = await getbroadcasterUserData();
        this.broadcasterUsers = sup.data.pageItems;
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },

    editbroadcaster(id) {
      this.$router.push({ name: "Edit Broadcaster", params: { id: id } });
    },
    editchannel(id) {
      this.$router.push({ name: "Edit Channel", params: { id: id } });
    },
    editChannelMapping(id) {
      this.$router.push({ name: "Edit Product Mapping", params: { id: id } });
    },
    async deleteData(id) {
      if (this.togglebroadcaster) {
        try {
          await this.$store.dispatch("broadcaster/deleteBroadcasterAction", id);
          this.getbroadcasterData();
          this.$swal({
            title: "Success",
            icon: "success",
            text: "Broadcaster Successfully Deleted",
            type: "success",
          });
          this.editJobsPopup = false;
        } catch (e) {
          this.$toasted.error(e.message);
        }
      }
      if (this.togglechannel) {
        try {
          await this.$store.dispatch("broadcaster/deleteChannelAction", id);
          this.getChannelData();
          this.$swal({
            title: "Success",
            icon: "success",
            text: "Channel Successfully Deleted",
            type: "success",
          });
          this.editJobsPopup = false;
        } catch (e) {
          this.$toasted.error(e.message);
        }
      }
      if (this.toggleproductmapping) {
        try {
          await this.$store.dispatch(
            "broadcaster/deleteChannelMappingAction",
            id
          );
          this.$swal({
            title: "Success",
            icon: "success",
            text: "Product Mapping Successfully Deleted",
            type: "success",
          });
          this.getProductMapping();
          this.editJobsPopup = false;
        } catch (e) {
          this.$toasted.error(e.message);
        }
      }
    },
  },
  watch: {},
  mounted() {
    this.getbroadcasterData();
    this.getChannelData();
    this.getProductMapping();
  },
};
</script>
<style scoped>
.vs-table--search {
  max-width: 100%;
  margin-left: 0px !important;
}

.vuesax-app-is-ltr .vs-table--search {
  margin-left: 0;
}

.vs-search-categeory {
  margin-top: 17px;
}

ul {
  list-style-type: none;
  margin: 0;
  padding: 0;

  overflow: hidden;
  background-color: rgba(var(--vs-primary), 1) !important;
  border-radius: 0.2rem;
}

li {
  float: left;
  font-weight: 550;
  font-size: 0.8rem;
  cursor: pointer;
}

li a {
  display: block;
  color: #fff;
  text-align: center;
  padding: 14px 16px;
  text-decoration: none;
  border: solid 0.2rem rgba(var(--vs-primary), 1);
}

li a:hover:not(.active) {
  border: solid 0.2rem rgba(var(--vs-primary), 1) !important ;
  background-color: #fff;
  color: rgba(var(--vs-primary), 1);
  box-shadow: rgba(var(--vs-primary), 1) 0px 7px 29px 0px;
}

.active {
  background-color: #fff;
  color: #333;
  border: solid 0.2rem #fff;
}
.trsnVx {
  position: absolute;
}
.slide-fade-leave-active,
.slide-fade-enter-active {
  transition: all 0.4s ease-out;
}

.slide-fade-enter-from {
  transform: translateX(-20px);
  opacity: 0;
}
.slide-fade-leave-to {
  transform: translateX(+20px);
  opacity: 0;
}
.inventory_tabSec >>> .con-vs-tabs .con-ul-tabs {
  width: 50%;
  position: absolute;
  top: 1.3rem;
}
.inventory_tabSec >>> .con-vs-tabs .vs-tabs--ul {
  box-shadow: none !important;
}
.product-order-status.vs-chip-success {
  background: #d5ebdb !important;
  border: 1px solid #34a853;
  color: #34a853 !important;
}
.product-order-status.vs-chip-orange {
  background: #fffae7 !important;
  border: 1px solid #ffcb14;
  color: #ffcb14 !important;
}
.view_editTable_btn {
  background: transparent;
  cursor: pointer;
}
</style>
